import { useAtom } from 'jotai';

import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';

import { DMConversation } from '@/components/pages/conversations/SocialInbox/types';

import { selectedMessagesAtom } from '@/components/pages/conversations/SocialInbox/atoms';

import Checkbox from '@/components/base/Checkbox';

type SelectMessageActionProps = {
    message: DMConversation;
};

export const SelectMessageAction = ({ message }: SelectMessageActionProps) => {
    const [selectedMessages, setSelectedMessages] = useAtom(selectedMessagesAtom);
    const { currentSocialInbox } = useSocialInboxNavigation();

    const isSelected = selectedMessages[currentSocialInbox]?.includes(
        message.meta_conversation_id.toString()
    );

    const selectMessage = () => {
        if (isSelected) {
            setSelectedMessages({
                ...selectedMessages,
                [currentSocialInbox]: selectedMessages[currentSocialInbox].filter(
                    (id) => id !== message.meta_conversation_id.toString()
                )
            });
        } else {
            setSelectedMessages({
                ...selectedMessages,
                [currentSocialInbox]: [
                    ...selectedMessages[currentSocialInbox],
                    message.meta_conversation_id.toString()
                ]
            });
        }
    };

    return (
        <Checkbox
            data-testid="select-message-action"
            boxSize="sm"
            checked={isSelected}
            onChange={selectMessage}
        />
    );
};
